import { normalizePlanSettings, PLAN_SETTINGS_VERSION } from './planSettings.js'

// Empty plan slots normalize to null; a stored row only needs the plans that
// actually exist.
const compactSettings = (settings) => Object.fromEntries(
  Object.entries(settings).filter(([, value]) => value !== null && value !== undefined),
)

// Cloud records may keep source identity and confirmation timing, but never
// document excerpts. A source excerpt can contain both plan terms and personal
// information, and the browser-local review log is sufficient for v1.
const cloudSafeSettings = (planSettings) => {
  const settings = compactSettings(normalizePlanSettings(planSettings, PLAN_SETTINGS_VERSION))
  const metadata = Object.fromEntries(Object.entries(settings.settingMetadataByPath || {}).map(([planKey, records]) => [
    planKey,
    Object.fromEntries(Object.entries(records || {}).map(([path, record]) => {
      const { sourceExcerpt: _sourceExcerpt, ...safeRecord } = record || {}
      return [path, safeRecord]
    })),
  ]))
  if (Object.keys(metadata).length) settings.settingMetadataByPath = metadata
  else delete settings.settingMetadataByPath
  const profile = settings.employerProfile
  if (profile && profile.eligibleEmployeeCount === null
    && profile.controlledGroupStatus === 'unknown'
    && profile.affiliatedServiceGroupStatus === 'unknown'
    && profile.priorDbPlanHistory === 'unknown') {
    delete settings.employerProfile
  }
  return settings
}

// Central allowlist for every client-book write. Keeping this builder separate
// makes the privacy boundary easy to test without a browser or Supabase client.
export function buildClientPlanInsert({ clientName, planSettings }) {
  return {
    client_name: String(clientName || '').trim(),
    plan_settings: cloudSafeSettings(planSettings),
    plan_settings_version: PLAN_SETTINGS_VERSION,
  }
}

export function buildClientPlanUpdate(fields = {}) {
  const patch = {}
  if (fields.clientName !== undefined) {
    patch.client_name = String(fields.clientName || '').trim()
  }
  if (fields.planSettings !== undefined) {
    patch.plan_settings = cloudSafeSettings(fields.planSettings)
    patch.plan_settings_version = PLAN_SETTINGS_VERSION
  }
  return patch
}
